import { Accordion } from '@gds/Accordion/Accordion';

import { Typography } from '@gds/Typography/Typography';

import Cta from '../CTA/Cta';
import { CtaContent } from '../CTA/Cta.entity';
import { RichText } from '../RichText/RichText';

import { FaqSectionProps } from './FaqSection.entity';

import styles from './FaqSection.module.css';

export const FaqSection = ({
  id,
  title,
  subtitle,
  questionAnswerPairs,
  cta,
  useHTagsInAccordion,
}: FaqSectionProps) => {
  const ctaData = (cta?.[0] || {}) as CtaContent;

  return (
    <div id={id} className={styles.root}>
      {title && (
        <Typography variant="h2" className={styles.title}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="body3" Component="p" className={styles.description}>
          {subtitle}
        </Typography>
      )}
      <div className={styles.accordions} data-testid="accordion-faq">
        {questionAnswerPairs?.map(item => {
          const TitleComponent = useHTagsInAccordion ? (
            <Typography variant="h5" Component="h2" className={styles.accordionTitle}>
              {item.accordionTitle}
            </Typography>
          ) : (
            item.accordionTitle
          );

          return (
            <Accordion title={TitleComponent} key={item.accordionTitle}>
              <RichText noPadding richText={item.accordionContent} />
            </Accordion>
          );
        })}
      </div>
      <Cta cta={ctaData} className={styles.button} data-testid="faqButton" />
    </div>
  );
};
